(function ($) {
	'use strict';

	/*
	 * Função que insere a classe scrolled no header 
	 * quando o scroll da página ultrapassa determinado valor
	 */
	var headerPosition = function () {
		var scrollTop = $(window).scrollTop(),
			$header = $('header');

		if (scrollTop >= 1) {
			$header.addClass('scrolled');
		} else {
			$header.removeClass('scrolled');
		}
	};

	$(window).load(function () {
		if ($('header').data('scrollable')) {
			headerPosition();
		}
	});

	$(window).scroll(function () {
		if ($('header').data('scrollable')) {
			headerPosition();
		}
	});

}(jQuery));